import { useMsal } from '@azure/msal-react';
import { ArrowDownIcon, ArrowUpIcon } from '@chakra-ui/icons';
import { Box, Flex, Icon, Text, Center, Button } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import { useState } from 'react';

import { NavLink, useLocation } from 'react-router-dom';

function NavItem({ icon, to, base, items, requiredRoles, children, ...rest }) {
  const { accounts } = useMsal();

  // Safe access to user roles with proper null/undefined checks
  const userAccount = accounts?.[0];
  const idTokenClaims = userAccount?.idTokenClaims;
  const roles = idTokenClaims?.roles || [];

  const { pathname } = useLocation();

  const isActive = pathname.includes(base);
  const shouldRenderItem =
    requiredRoles.length === 0 ||
    roles.some((item) => requiredRoles.includes(item));

  const [isToggled, setIsToggled] = useState(false);

  const handleToggleClick = () => {
    setIsToggled(!isToggled);
  };

  return (
    <Box>
      {shouldRenderItem && (
        <>
          <NavLink {...(to ? { to } : { onClick: handleToggleClick })}>
            <Box
              style={{ textDecoration: 'none' }}
              _focus={{ boxShadow: 'none' }}
            >
              <Flex
                align="center"
                direction="column"
                p="4"
                mb="1"
                bg={isActive ? '#ad3648' : ''}
                cursor="pointer"
                _hover={{
                  bg: '#ad3648',
                }}
                {...rest}
              >
                {icon && (
                  <Icon
                    fontSize="2xl"
                    color="white"
                    _groupHover={{
                      color: 'white',
                    }}
                    as={icon}
                  />
                )}
                <Center mt={2}>
                  {items.length > 0 ? (
                    <Button
                      fontWeight={400}
                      color="white"
                      variant="link"
                      fontSize="8px"
                      rightIcon={
                        isToggled ? <ArrowUpIcon /> : <ArrowDownIcon />
                      }
                    >
                      {children}
                    </Button>
                  ) : (
                    <Text fontSize="8px" noOfLines={2} color="white">
                      {children}
                    </Text>
                  )}
                </Center>
              </Flex>
            </Box>
          </NavLink>
          {isToggled && items.length > 0 && (
            <ul>
              {items.map((item) => (
                <NavItem
                  key={item.name}
                  to={item.to}
                  base={item.base}
                  icon={item.icon}
                  requiredRoles={item.roles}
                >
                  {item.name}
                </NavItem>
              ))}
            </ul>
          )}
        </>
      )}
    </Box>
  );
}

NavItem.defaultProps = {
  to: null,
  items: [],
  requiredRoles: [],
};

NavItem.propTypes = {
  icon: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  to: PropTypes.string,
  base: PropTypes.string.isRequired,
  items: PropTypes.array,
  requiredRoles: PropTypes.array,
};

export default NavItem;
